export const not = <Inputs extends any[]>(
  wrappedFunction: (...inputs: Inputs) => boolean | undefined | null
) => {
  return (...inputs: Inputs) => !wrappedFunction(...inputs)
}

export function isNotFalse<TValue>(value: TValue | false): value is Exclude<TValue, false> {
  return value !== false
}

type FalsyValues = false | 0 | '' | null | undefined | typeof NaN

export function isTruthy<TValue>(
  value: TValue | FalsyValues
): value is Exclude<TValue, FalsyValues> {
  return !!value
}

export function isFalsy(value: any): value is FalsyValues {
  return !!value
}
